import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { Mic, Mail, Lock, Eye, EyeOff, MailWarning } from 'lucide-react';

export default function LoginPage() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  // Аккаунт заблокирован за неподтверждённый email: бэкенд помечает такой отказ
  // code='email_not_verified', чтобы его можно было отличить от прочих 403.
  const [emailBlocked, setEmailBlocked] = useState(false);
  const [resending, setResending] = useState(false);
  const { login, requestVerification } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      const data = err.response?.data;
      setEmailBlocked(data?.code === 'email_not_verified');
      toast.error(data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResending(true);
    try {
      await requestVerification(form.email, form.password);
      toast.success('Confirmation email sent — check your inbox.');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Could not send the confirmation email');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <Mic size={32} />
          <h1>Voice AI Portal</h1>
          <p>AI-powered voice agent management</p>
        </div>

        {emailBlocked && (
          <div className="banner banner--warning" style={{ marginBottom: 16 }}>
            <MailWarning size={18} />
            <span>
              This account is locked until you confirm your email address. Open the link we sent
              you, or request a new one.
            </span>
            <button
              className="btn btn-sm btn-ghost"
              onClick={handleResend}
              disabled={resending}
              style={{ marginLeft: 'auto' }}
            >
              {resending ? 'Sending...' : 'Resend'}
            </button>
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label>Email</label>
            <div className="input-icon">
              <Mail size={16} />
              <input
                type="email"
                placeholder="you@company.com"
                value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Password</label>
            <div className="input-icon">
              <Lock size={16} />
              <input
                type={showPass ? 'text' : 'password'}
                placeholder="••••••••"
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                required
              />
              <button type="button" className="input-icon-right" onClick={() => setShowPass(!showPass)}>
                {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="auth-footer">
          Don't have an account? <Link to="/register">Sign up free</Link>
        </p>
      </div>
    </div>
  );
}
